import React from 'react';
import { Section } from './ui/Section';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function SystemFramework() {
  const {
    t
  } = useLanguage();
  const steps = t.systemFramework.steps;
  return <Section className="border-y border-luxury-gold/10 bg-luxury-black" data-id="element-161">
      <div className="max-w-6xl mx-auto" data-id="element-162">
        <div className="text-center mb-16" data-id="element-163">
          <span className="text-luxury-gold text-xs uppercase tracking-[0.2em] mb-4 block" data-id="element-164">
            {t.systemFramework.label}
          </span>
          <h2 className="font-serif text-3xl md:text-4xl text-white" data-id="element-165">
            {t.systemFramework.headline.line1}{' '}
            <span className="italic text-luxury-gold" data-id="element-166">
              {t.systemFramework.headline.span}
            </span>
          </h2>
        </div>

        {/* Desktop View */}
        <div className="hidden md:flex justify-between items-center relative" data-id="element-167">
          {/* Connecting Line */}
          <div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-luxury-gold/30 to-transparent -z-10" data-id="element-168" />

          {steps.map((step, i) => <div key={i} className="flex items-center" data-id="element-169">
              <div className="relative group" data-id="element-170">
                <div className="w-32 h-32 flex flex-col items-center justify-center bg-luxury-charcoal border border-luxury-gold/20 rounded-full z-10 hover:border-luxury-gold/60 hover:bg-luxury-gold/5 transition-all duration-500" data-id="element-171">
                  <span className="text-luxury-gold/30 text-xs mb-1 font-serif" data-id="element-172">
                    0{i + 1}
                  </span>
                  <span className="text-white text-xs font-medium tracking-widest" data-id="element-173">
                    {step}
                  </span>
                </div>
                <div className="absolute inset-0 bg-luxury-gold/5 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-174" />
              </div>

              {i < steps.length - 1 && <ArrowRight className="w-5 h-5 text-luxury-gold/40 mx-4" data-id="element-175" />}
            </div>)}
        </div>

        {/* Mobile View */}
        <div className="md:hidden space-y-4" data-id="element-176">
          {steps.map((step, i) => <div key={i} className="flex items-center justify-between p-4 bg-luxury-charcoal/50 border border-white/5" data-id="element-177">
              <span className="text-luxury-gold/50 font-serif" data-id="element-178">0{i + 1}</span>
              <span className="text-white tracking-widest text-sm" data-id="element-179">{step}</span>
            </div>)}
        </div>
      </div>
    </Section>;
}